module.exports = __webpack_public_path__ + "img/courseY.34e7017e.png";